import {connect} from "react-redux";
import InactiveFse from "./InactiveFse";
import {bindActionCreators} from "redux";
import {getInactiveFsesRequest, tollById, getFseActivationCheckRequest, callLogsRequest, tollPendingMeetingRequest, nearestPlazaFromOperatorLocationRequest,
    checkSBIIssuanceRequest} from "../../../../service/FasttagToll/action";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";

const mapStateToProps = (state) => ({
    getInactiveFsesResponse:state.FasttagToll.getInactiveFsesResponse,
    tollView:state.FasttagToll.tollView,
    getFseActivationCheckResponse:state.FasttagToll.getFseActivationCheckResponse,
    callLogsResponse:state.FasttagToll.callLogsResponse,
    tollPendingMeetingResponse:state.FasttagToll.tollPendingMeetingResponse,
    nearestPlazaFromOperatorLocationResponse:state.FasttagToll.nearestPlazaFromOperatorLocationResponse,
    checkSBIIssuanceResponse:state.FasttagToll.checkSBIIssuanceResponse,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getInactiveFsesRequest,
            tollById,
            getFseActivationCheckRequest,
            callLogsRequest,
            tollPendingMeetingRequest,
            documentUploadUrlPublic,
            nearestPlazaFromOperatorLocationRequest,
            checkSBIIssuanceRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(InactiveFse);
